import { render, staticRenderFns } from "./NavbarShop.vue?vue&type=template&id=f861f4d6"
import script from "./NavbarShop.vue?vue&type=script&lang=js"
export * from "./NavbarShop.vue?vue&type=script&lang=js"
import style0 from "./NavbarShop.vue?vue&type=style&index=0&id=f861f4d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports